import { render } from "./LoginActivity.vue?vue&type=template&id=804d1ffc"
import script from "./LoginActivity.vue?vue&type=script&lang=js"
export * from "./LoginActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__